// extracted by mini-css-extract-plugin
module.exports = {"logo":"NavigationLogo__logo___2N3z9"};